module.exports = __webpack_public_path__ + "9c3caab13c96a2d6a1992e817b8b6228.svg";